import modelBaseV2 from "../../model-base-v2.model";

const DailyBatchCheckModel = {
  searchDailyBatchCheck: (params) => {
    const qs = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/intf-edi/IntfDailyBatchCheck?${qs}`);

  }
}
export default DailyBatchCheckModel